import { useState } from 'react';
export const useIsInputFocused = ({ disabled, readOnly, onBlur, onFocus, }) => {
    const [isFocused, setIsFocused] = useState(false);
    const handleFocus = (event) => {
        if (!disabled && !readOnly)
            setIsFocused(true);
        onFocus?.(event);
    };
    const handleBlur = (event) => {
        if (!disabled)
            setIsFocused(false);
        onBlur?.(event);
    };
    return { isFocused, handleFocus, handleBlur };
};
